export default __webpack_public_path__ + "static/media/intake.83eb7dd0.svg";